import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
import { queryClient } from './lib/queryClient';
import './index.css';

const container = document.getElementById('root');
if (!container) throw new Error('Root element #root not found');

// SSG hand-off: the exact front door "/" arrives with the landing PRERENDERED inside #root
// (dist/landing.html). Record that BEFORE render() replaces it — LandingPage consumes this one-shot
// flag (peekPrerenderedMarkupFlag; cleared in its mount effect) to skip its entrance reveals, so the
// already-visible static content never blinks out and re-animates. Checked here (not in a
// component): once React commits, hasChildNodes() is true on every route.
(window as unknown as { __duckPrerenderedLanding?: boolean }).__duckPrerenderedLanding =
  window.location.pathname === '/' && container.hasChildNodes();

// Note: intentionally not wrapped in <StrictMode> — the office mounts a Pixi app and a single
// realtime WebSocket; StrictMode's dev double-invoke would connect/disconnect twice. The office
// effect still cleans up correctly on unmount.
createRoot(container).render(
  <QueryClientProvider client={queryClient}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </QueryClientProvider>,
);
